import $ from 'jquery'

export const customPreloader = () => {
  const preloader = $( '#preloader' )
				preloader.fadeOut(300);
}